<!--
  File : SignUp.vue
  Reference: materialdesignicons.com
-->

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-card class="ma-3 elevation-0" width="480">
        <v-toolbar class="elevation-0 mb--20" color="white">
          <v-row justify="center">
            <v-toolbar-title class="primary--text">회원 가입</v-toolbar-title>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-row class="pl-3 pr-3 pt-3">
              <v-select prepend-icon="mdi-map-marker" v-model="studio" :items="studios" label="스튜디오" />
            </v-row>
            <v-text-field
              id="email"
              prepend-icon="mdi-account"
              type="email"
              label="아이디 (3자이상)"
              @keyup.13.stop.prevent="next('password')"
              v-model="email"
              class="pb-0"
            />
            <v-text-field
              id="password"
              prepend-icon="mdi-lock"
              type="password"
              label="비밀번호 (6자이상)"
              @keyup.13.stop.prevent="next('confirm')"
              v-model="password"
              class="pt-0 pb-0"
            />
            <v-text-field
              id="confirm"
              prepend-icon="mdi-lock"
              type="password"
              label="비밀번호확인"
              @keyup.13.stop.prevent="next('name')"
              v-model="confirm"
              class="pt-0 pb-0"
            />
            <v-text-field
              id="name"
              prepend-icon="mdi-tag"
              type="name"
              label="성명 (2자이상)"
              @keyup.13.stop.prevent="next('mobile')"
              v-model="name"
              class="pt-0 pb-0"
            />
            <v-radio-group row v-model="sex" class="pt-0 pb-0" v-if="privacy">
              <v-icon class="pr-3">mdi-human-male-female</v-icon>
              <v-radio value=1 label="남" />
              <v-radio value=2 label="여" />
            </v-radio-group>

            <v-text-field v-if="privacy"
              id="birth"
              prepend-icon="mdi-cake-variant"
              :type="util.isAndroid() ? 'text' : 'date'"
              :label="'생년월일' + (util.isAndroid() ? ' (예: 1990-01-01)' : '')"
              v-model="birth"
            />
            <v-text-field
              id="mobile"
              prepend-icon="mdi-cellphone"
              type="tel"
              label="휴대폰 번호 (필수)"
              @keyup.13.stop.prevent="next('address')"
              v-model="mobile"
              class="pt-0 pb-0"
            />
            <v-text-field
              id="address"
              prepend-icon="mdi-home"
              type="text"
              label="주소"
              v-model="address"
              class="pt-0"
            />
          </v-form>
        </v-card-text>
        <v-row class="pl-5 mt--20">
          <v-col><v-checkbox v-model="consent" @click="onAgree()" label="회원약관 동의" /></v-col>
        </v-row>
        <v-card-actions>
          <v-col class="text-left" cols="6">
            <a @click="signin()" class="font-16">로그인</a>
          </v-col>
          <v-col class="text-right" cols="6">
            <v-btn class="elevation-0 font-14" color="secondary" @click.prevent="signup()">확인</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>

    <v-container>
      <v-dialog v-model="dialog" width="100%">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            회원 약관
          </v-card-title>
          <iframe src="https://balletfitkorea.com/?mode=policy"></iframe>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-spacer />
            <v-btn class="elevation-0 font-16" text color="normal" @click="onAgree(false)">취소</v-btn>
            <v-btn class="elevation-0 font-16" text color="primary" @click="onAgree(true)">약관을 읽고 동의</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  name: 'SignUp',

  data () {
    return {
      dialog: false,
      consent: false,
      studios: [],
      levels: [],
      studio: 0,
      email: '',
      password: '',
      confirm: '',
      name: '',
      sex: 0,
      birth: '',
      mobile: '',
      address: '',
      privacy: true,
      util: util
    }
  },

  props: {
    source: String,
  },

  methods: {
    onAgree: function (agree) {
      if (agree == null) {
        this.dialog = this.consent
      }
      else {
        this.dialog = false
        this.consent = agree
      }
    },

    next: function (type) {
      if (type == 'password' && this.email.trim().length >= 3) {
        document.getElementById('password').focus()
      }
      else if (type == 'confirm' && this.password.length >= 6) {
        document.getElementById('confirm').focus()
      }
      else if (type == 'name' && this.confirm == this.password) {
        document.getElementById('name').focus()
      }
      else if (type == 'mobile' && this.name.trim().length >= 2) {
        document.getElementById('mobile').focus()
      }
      else if (type == 'address' && this.mobile.length >= 10) {
        document.getElementById('address').focus()
      }
    },

    signup: function () {
      if (!this.consent) {
        alert('회원약관에 동의하셔야 회원가입을 하실 수 있습니다.')
        return
      }
      if (this.studio == 0) {
        alert('스튜디오를 선택해주세요.')
        return
      }
      if (this.email.trim().length < 3) {
        alert('아이디는 3자 이상 입력해주세요.')
        document.getElementById('email').focus()
        return
      }
      if (this.password.length < 6) {
        alert('6자 이상의 비밀번호를 입력해주세요.')
        document.getElementById('password').focus()
        return
      }
      if (this.confirm != this.password) {
        alert('정확한 비밀번호를 입력해주세요.')
        document.getElementById('confirm').focus()
        return
      }
      if (this.name.trim().length < 2) {
        alert('정확한 이름을 입력해주세요.')
        document.getElementById('name').focus()
        return
      }
      if (this.mobile.length < 10) {
        alert('정확한 휴대폰번호를 입력해주세요.')
        document.getElementById('mobile').focus()
        return
      }
      let params = new URLSearchParams()
      params.append('email', this.email.trim())
      params.append('password', this.password)
      params.append('name', this.name.trim())
      params.append('sex', this.sex)
      params.append('birth', this.birth)
      params.append('mobile', this.mobile ? this.mobile : '')
      params.append('address', this.address ? this.address : '')
      params.append('studio', this.studio)
      params.append('level', 0)
      axios.post('/api/user/signup', params, util.headers)
      .then(response => {
        if (response.data.error) {
          if (response.data.error == 'email') {
            alert('이미 사용중인 아이디입니다. 다른 아이디를 사용해주세요.')
            this.email = ''
            document.getElementById('email').focus()
          }
        }
        else {
          alert('발레핏코리아 회원가입을 축하드립니다. 로그인 하실 수 있습니다.')
          this.$router.push('/login')
        }
      })
    },

    cancel: function () {
      this.$router.push('/')
    },

    signin: function () {
      this.$router.push('/login')
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json && JSON.parse(localStorage.getItem('login'))) {
      this.$router.push('/')
      return
    }

    util.getStudios((studios, error) => {
      if (error) console.log(error)
      this.studios = studios
      this.studios.shift()
    })
  }
}
</script>

<style scoped>
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.mt--20 {
  margin-top: -20px;
}
.mb--20 {
  margin-bottom: -20px;
}
iframe {
  width: 100%;
  height: 400px;
  border: 0;
}
</style>
